import logo from "assets/img/logo/logo_aig_login-2.png";
import PropTypes from "prop-types";
import React from "react";
import { Button, Form, FormGroup, Input, Label, Alert } from "reactstrap";
import { Textbox } from "react-inputs-validation";
import { Link } from "react-router-dom";

class AuthForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      validate: false,
      hasNameError: true,
      name: ""
    };
    this.validateForm = this.validateForm.bind(this);
  }
  get isLogin() {
    return this.props.authState === STATE_LOGIN;
  }

  get isSignup() {
    return this.props.authState === STATE_SIGNUP;
  }

  changeAuthState = authState => event => {
    event.preventDefault();

    this.props.onChangeAuthState(authState);
  };

  handleSubmit = event => {
    event.preventDefault();
  };
  toggleValidating(validate) {
    this.setState({ validate });
  }

  validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    const {
      name,
      // job,
      // country,
      // agreement,
      // description,
      hasNameError
    } = this.state;
    //console.log("All validated!", this.state);
    if (!hasNameError) {
      this.props.onClickRecuperar({ correo: name });
      //console.log("All validated!");
    }
  }

  renderButtonText() {
    const { buttonText } = this.props;

    if (!buttonText && this.isLogin) {
      return "ENVIAR";
    }

    if (!buttonText && this.isSignup) {
      return "Signup";
    }

    return buttonText;
  }

  render() {
    const {
      showLogo,
      usuarioLabel,
      usuarioInputProps,
      children,
      onLogoClick,
      handleChangeCorreo,
      onClickRecuperar,
      correo
    } = this.props;

    const { validate } = this.state;

    return (
      <form onSubmit={this.validateForm}>
        {showLogo && (
          <div className="text-center pb-4">
            <img
              src={logo}
              className="login-logo"
              style={{ cursor: "pointer" }}
              alt="logo"
              onClick={onLogoClick}
            />
          </div>
        )}
        <div>
          <h2>Recuperar Contraseña</h2>
          <div>
            Por favor ingresa tu correo electrónico y revisa tu bandeja de
            entrada
          </div>
          <hr />
          <p />
        </div>

        <Label for={usuarioLabel}>{usuarioLabel}</Label>
        {/*<Input {...usuarioInputProps } onChange={handleChangeCorreo} />*/}
        <Textbox
          tabIndex="1"
          type="email"
          id="name"
          name="name"
          placeholder="jperez@email.com"
          value={this.state.name}
          onChange={(name, e) => {
            this.setState({ name: name });
            //handleChangeCorreo(e)
          }}
          classNameInput="form-control"
          validate={validate}
          validationCallback={res =>
            //console.log(res)
            this.setState({ hasNameError: res, validate: false })
          } // Optional.[Func].Default: none. Return the validation result.
          onBlur={e => {
            this.setState({ blur: true });
            //console.log(e);
          }} // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
          // onFocus={(e) => {console.log(e);}} // Optional.[Func].Default: none.
          // onClick={(e) => {console.log(e);}} // Optional.[Func].Default: none.
          validationOption={{
            name: "Inputcorreo", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
            check: true, // Optional.[Bool].Default: true. To determin if you need to validate.
            required: true,
            msgOnError: "Por favor ingrese un correo válido",
            customFunc: email => {
              const reg = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              if (reg.test(String(email).toLowerCase())) {
                return true;
              } else {
                return "no es un correo válido";
              }
            } // Optional.[Bool].Default: true. To determin if it is a required field.
            // type: 'string', // Optional.[String].Default: "string". Validation type, options are ['string', 'number'].
            // showMsg: true, // Optional.[Bool].Default: true. To determin display the error message or not.
            // min: 2, // Optional.[Number].Default: 0. Validation of min length when validationOption['type'] is string, min amount when validationOption['type'] is number.
            // max: 10, // Optional.[Number].Default: 0. Validation of max length when validationOption['type'] is string, max amount when validationOption['type'] is number.
            // length: 2, // Optional.[Number].Default: 0. Validation of exact length of the value.
            // compare: '3', // Optional.[String].Default: "" Compare this value to 3 to see if they are equal.
            // reg: /^\d{18}|\d{15}$/, // Optional.[Bool].Default: "" Custom regex.
            // regMsg: 'failed in reg.test(${value})', // Optional.[String].Default: "" Custom regex error message.
            // locale: 'en-US', // Optional.[String].Default: "en-US". For error message display. Current options are ['zh-CN', 'en-US']; Default is 'en-US'.
            // msgOnError: "Your custom error message if you provide the validationOption['msgOnError']", // Optional.[String].Default: "" Show your custom error message no matter what when it has error if it is provied.
            // msgOnSuccess: "Your custom success message if you provide the validationOption['msgOnSuccess']. Otherwise, it will not show, not even green border." // Optional.[String].Default: "". Show your custom success message no matter what when it has error if it is provied.
            // customFunc: res => { // Optional.[Func].Default: none. Custom function. Returns true or err message
            //   if (res != 'milk') {
            //     return 'Name cannot be other things but milk';
            //   }
            //   return true;
            // }
          }}
        />

        <Button
          size="lg"
          className="bg-gradient-theme-left border-0"
          block
          onClick={this.validateForm}
        >
          <i className="glyphicon glyphicon-send" aria-hidden="true" />
          {this.renderButtonText()}
        </Button>
        <div className="text-center pt-1">
          <h6>
            <p />
            <Link className={"btn-color-main"} to={`/`}>Regresar</Link>
          </h6>
        </div>
        <input type="submit" style={{ display: "none" }} />

        {children}
      </form>
    );
  }
}

export const STATE_LOGIN = "LOGIN";
export const STATE_SIGNUP = "SIGNUP";

AuthForm.propTypes = {
  authState: PropTypes.oneOf([STATE_LOGIN, STATE_SIGNUP]).isRequired,
  showLogo: PropTypes.bool,
  usuarioLabel: PropTypes.string,
  usuarioInputProps: PropTypes.object,
  contasenaLabel: PropTypes.string,
  contasenaInputProps: PropTypes.object,
  confirmPasswordLabel: PropTypes.string,
  confirmPasswordInputProps: PropTypes.object,
  onLogoClick: PropTypes.func
};

AuthForm.defaultProps = {
  authState: "LOGIN",
  showLogo: true,
  usuarioLabel: "Correo Electrónico",
  usuarioInputProps: {
    type: "email",
    placeholder: "jperez@email.com"
  },
  contasenaLabel: "Contraseña",
  contasenaInputProps: {
    type: "password",
    placeholder: "Contraseña"
  },
  confirmPasswordLabel: "Confirm Password",
  confirmPasswordInputProps: {
    type: "password",
    placeholder: "confirm your password"
  },
  onLogoClick: () => {}
};

export default AuthForm;
